import React from 'react'
import Immutable from 'immutable'
import styled, { css } from 'styled-components'
import { defaultTheme } from '../../data/themes'
import Icon from '../icon'
import $ from 'jquery'

const EMPTY_LIST = Immutable.List([])

const Tabs = styled.div``

const Tab = styled.div``

const Header = styled.div`
  color: ${(props) =>
		props.theme.tabVerticalHeaderColor || defaultTheme.tabVerticalHeaderColor};
  font-size: ${(props) =>
		props.theme.tabVerticalHeaderFontSize ||
		defaultTheme.tabVerticalHeaderFontSize};
  font-weight: ${(props) =>
		props.theme.tabVerticalHeaderFontWeight ||
		defaultTheme.tabVerticalHeaderFontWeight};
  padding: ${(props) =>
		props.theme.tabVerticalHeaderPadding ||
		defaultTheme.tabVerticalHeaderPadding};
  margin: ${(props) =>
		props.theme.tabVerticalHeaderMargin ||
		defaultTheme.tabVerticalHeaderMargin};
`

const TabPaneWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  max-width: ${(props) => props.maxWidth};
  margin: ${(props) => props.margin};
  margin-right: ${(props) => props.marginRight};
  flex-direction: ${(props) => (props.vertical ? 'row' : 'column')};
`

const ScrollIcons = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
`

const TabStripWrapper = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  z-index: 0;
  position: relative;
  ${ScrollIcons} {
    display: none;
  }
  ${(props) =>
		props.vertical
			? css`
          .bottomLine {
            display: none;
          }
          width: ${(props) => props.width};
          padding: ${(props) =>
					props.theme.tabVerticalStripPadding ||
					defaultTheme.tabVerticalStripPadding};
          ${Tab} {
            display: block;
            white-space: nowrap;
            outline: none;

            &.selected {
              cursor: default;
            }

            &:not(.selected) {
              cursor: pointer;

              &:hover {
                text-decoration: ${(props) =>
					props.theme.tabVerticalHoverTextDecoration ||
					defaultTheme.tabVerticalHoverTextDecoration};
              }
            }
            color: ${(props) =>
					props.theme.tabVerticalColor || defaultTheme.tabVerticalColor};
            font-size: ${(props) =>
					props.theme.tabVerticalFontSize ||
					defaultTheme.tabVerticalFontSize};
            font-weight: ${(props) =>
					props.theme.tabVerticalFontWeight ||
					defaultTheme.tabVerticalFontWeight};
            padding: ${(props) =>
					props.theme.tabVerticalPadding ||
					defaultTheme.tabVerticalPadding};
            margin: ${(props) =>
					props.theme.tabVerticalMargin || defaultTheme.tabVerticalMargin};

            &.selected {
              color: ${(props) =>
					props.theme.tabVerticalSelectedColor ||
					defaultTheme.tabVerticalSelectedColor};
              text-shadow: ${(props) =>
					props.theme.tabVerticalSelectedTextShadow ||
					defaultTheme.tabVerticalSelectedTextShadow};
              font-weight: ${(props) =>
					props.theme.tabVerticalSelectedFontWeight ||
					defaultTheme.tabVerticalSelectedFontWeight};
            }
          }
        `
			: css`
          ${Tabs} {
            width: calc(100% - 40px);
            overflow: hidden;
          }
          ${ScrollIcons} {
            padding: ${(props) =>
					props.theme.tabHorizontalPadding ||
					defaultTheme.tabHorizontalPadding};
            padding-left: 0px;
            padding-right: 0px;
            display: block;
            width: 40px;
            text-align: center;
            .icon {
              &:not(:first-child) {
                margin-left: 6px;
              }
              font-size: 16px;
            }
          }
          border-bottom: ${(props) =>
					props.theme.tabStripHorizontalBottomBorder ||
					defaultTheme.tabStripHorizontalBottomBorder};
          white-space: nowrap;
          overflow: hidden;
          .bottomLine {
            display: block;
            position: absolute;
            width: 100%;
            left: 0px;
            z-index: 5;
            bottom: ${props.theme.tabHorizontalBottomLineBottom || '0px'};
            height: ${props.theme.tabHorizontalBottomLineHeight || '1px'};
            background: ${props.theme.tabHorizontalBottomLineColor};
          }

          ${Tab} {
            z-index: 0;
            display: inline-block;
            white-space: nowrap;
            outline: none;
            position: relative;

            &.selected {
              cursor: default;
            }
            &:not(.selected) {
              cursor: pointer;
            }
            color: ${(props) =>
					props.theme.tabHorizontalColor ||
					defaultTheme.tabHorizontalColor};
            background: ${(props) =>
					props.theme.tabHorizontalBackground ||
					defaultTheme.tabHorizontalBackground};
            opacity: ${(props) =>
					props.theme.tabHorizontalOpacity ||
					defaultTheme.tabHorizontalOpacity};

            font-size: ${(props) =>
					props.theme.tabHorizontalFontSize ||
					defaultTheme.tabHorizontalFontSize};
            font-weight: ${(props) =>
					props.theme.tabHorizontalFontWeight ||
					defaultTheme.tabHorizontalFontWeight};
            padding: ${(props) =>
					props.theme.tabHorizontalPadding ||
					defaultTheme.tabHorizontalPadding};
            margin: ${(props) =>
					props.theme.tabHorizontalMargin ||
					defaultTheme.tabHorizontalMargin};
            border-radius: ${(props) =>
					props.theme.tabHorizontalBorderRadius ||
					defaultTheme.tabHorizontalBorderRadius};
            border: ${(props) =>
					props.theme.tabHorizontalBorder ||
					defaultTheme.tabHorizontalBorder};
            border-bottom: ${(props) =>
					props.theme.tabHorizontalBorderBottom ||
					defaultTheme.tabHorizontalBorderBottom};

            &.selected {
              color: ${(props) =>
					props.theme.tabHorizontalSelectedColor ||
					defaultTheme.tabHorizontalSelectedColor};
              background: ${(props) =>
					props.theme.tabHorizontalSelectedBackground ||
					defaultTheme.tabHorizontalSelectedBackground};
              opacity: ${(props) =>
					props.theme.tabHorizontalSelectedOpacity ||
					defaultTheme.tabHorizontalSelectedOpacity};
              border-radius: ${(props) =>
					props.theme.tabHorizontalSelectedBorderRadius};
              border: ${(props) => props.theme.tabHorizontalSelectedBorder};
              border-bottom: ${(props) =>
					props.theme.tabHorizontalSelectedBorderBottom};

              text-shadow: ${(props) =>
					props.theme.tabHorizontalSelectedTextShadow ||
					defaultTheme.tabHorizontalSelectedTextShadow};
              font-weight: ${(props) =>
					props.theme.tabHorizontalSelectedFontWeight ||
					defaultTheme.tabHorizontalSelectedFontWeight};
              z-index: 10;
            }

            &:hover:not(.selected) {
              text-decoration: ${(props) =>
					props.theme.tabHorizontalHoverTextDecoration ||
					defaultTheme.tabHorizontalHoverTextDecoration};
            }
          }
        `}
`

const ContentWrapper = styled.div`
  flex-grow: 1;
  overflow: auto;
`

class TabStrip extends React.PureComponent {
	#resizeObserver
	#ref

	constructor() {
		super()
		this.onResize = this.onResize.bind(this)
		this.#resizeObserver = new ResizeObserver(this.onResize)
		this.#ref = React.createRef()
		this.state = {}
		this.scrollRight = this.scrollRight.bind(this)
		this.scrollLeft = this.scrollLeft.bind(this)
	}

	onResize() {
		const el = this.#ref.current
		const scrollLeft = el.scrollLeft
		const scrollWidth = el.scrollWidth
		const width = el.offsetWidth
		const right = scrollLeft + width

		let scrollLeftDisabled
		let scrollRightDisabled
		let scrollIconsVisible
		if (scrollLeft > 0 || right < scrollWidth) {
			scrollLeftDisabled = scrollLeft === 0
			scrollRightDisabled = right >= scrollWidth
			scrollIconsVisible = true
		} else {
			scrollIconsVisible = false
		}
		if (
			scrollLeftDisabled !== this.state.scrollLeftDisabled ||
			scrollRightDisabled !== this.state.scrollRightDisabled ||
			scrollIconsVisible !== this.state.scrollIconsVisible
		) {
			this.setState({
				scrollIconsVisible,
				scrollLeftDisabled,
				scrollRightDisabled
			})
		}
	}

	scrollLeft() {
		const el = this.#ref.current
		const scrollLeft = el.scrollLeft
		const width = el.offsetWidth
		const left = scrollLeft - width
		const leftEl = Array.prototype.filter.call(
			el.children,
			(e) => e.offsetLeft > left
		)[0]
		const scrollTo = leftEl ? leftEl.offsetLeft : left
		const me = this
		$(el).animate(
			{
				scrollLeft: scrollTo
			},
			300,
			function () {
				me.onResize()
			}
		)
	}

	scrollRight() {
		const el = this.#ref.current
		const scrollLeft = el.scrollLeft
		const width = el.offsetWidth
		const right = scrollLeft + width
		const rightEl = Array.prototype.filter.call(
			el.children,
			(e) => e.offsetWidth + e.offsetLeft > right
		)[0]
		const scrollTo = rightEl ? rightEl.offsetLeft : scrollLeft + width
		const me = this
		$(el).animate(
			{
				scrollLeft: scrollTo
			},
			300,
			function () {
				me.onResize()
			}
		)
	}

	componentDidMount() {
		this.#resizeObserver.observe(this.#ref.current)
	}

	componentWillUnmount() {
		this.#resizeObserver.disconnect()
	}

	render() {
		const selectedTabId = this.props.selectedTabId
		return (
			<TabStripWrapper
				className='ps-tabStrip'
				vertical={this.props.vertical}
				width={this.props.width}
			>
				{this.props.vertical && this.props.header && (
					<Header>{this.props.header}</Header>
				)}
				<Tabs ref={this.#ref}>
					{(this.props.tabs || EMPTY_LIST).map((tab, index) => {
						const id = tab.get('id') || '_tab$' + index
						const text = tab.get('text')
						return (
							<Tab
								key={index}
								className={id === selectedTabId ? 'selected' : ''}
								data-tabid={id}
								tabIndex='-1'
								onMouseDown={(e) => {
									e.preventDefault()
									e.target.focus()
									if (this.props.onTabSelected) {
										this.props.onTabSelected(id)
									}
								}}
							>
								{text === undefined
									? getPhrase(id)
									: typeof text === 'function'
										? text()
										: text}
							</Tab>
						)
					})}
				</Tabs>
				{this.state.scrollIconsVisible && (
					<ScrollIcons>
						<Icon
							name='back'
							disabled={this.state.scrollLeftDisabled}
							active
							onMouseDown={this.scrollLeft}
						/>
						<Icon
							name='forward'
							disabled={this.state.scrollRightDisabled}
							active
							onMouseDown={this.scrollRight}
						/>
					</ScrollIcons>
				)}
				<div className='bottomLine' />
			</TabStripWrapper>
		)
	}
}

export default class TabPane extends React.Component {
	render() {
		return (
			<TabPaneWrapper
				className='ps-tabPane'
				vertical={this.props.vertical}
				maxWidth={this.props.maxWidth}
				marginRight={this.props.marginRight}
				margin={this.props.margin}
			>
				<TabStrip
					tabs={this.props.tabs}
					vertical={this.props.vertical}
					header={this.props.header}
					selectedTabId={this.props.selectedTabId}
					onTabSelected={this.props.onTabSelected}
					width={this.props.tabStripWidth}
				/>
				<ContentWrapper className={this.props.contentClassName}>
					{this.props.children}
				</ContentWrapper>
			</TabPaneWrapper>
		)
	}
}
